import { render, staticRenderFns } from "./workAnalysis.vue?vue&type=template&id=77b68aef&scoped=true"
import script from "./workAnalysis.vue?vue&type=script&lang=js"
export * from "./workAnalysis.vue?vue&type=script&lang=js"
import style0 from "./workAnalysis.vue?vue&type=style&index=0&id=77b68aef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b68aef",
  null
  
)

export default component.exports